import React, { useState } from "react";
import { DelayInput } from "react-delay-input/lib/Component";
import DefaultButton from "../../styles/materialButtonStyle";
import Dropdown from "rc-dropdown";
import { useTranslation } from "react-i18next";

import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledShowFilterBtn
} from "../../elements/filter/styledFiter";

const SupportUserFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslation("clientsPage");

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "itemsPerPage": filterData["itemsPerPage"] ?? null,
    "firstname": "",
    "lastname": "",
    "email": ""
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
          <StyledFilterDropdownWrapper>
            <StyledFilterBlock actions>
              <StyledFilterGroup className="clear-btn">
                <DefaultButton
                  color="transparent"
                  onClick={handleClearFilter}
                >
                  {t("filter.clearBtn")}
                </DefaultButton>
              </StyledFilterGroup>
              <StyledFilterGroup className="clear-btn">
                <StyledFilterCloseBtn onClick={() => setVisible(false)} />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("filter.filterBy")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock>
              <StyledFilterGroup>
                <label htmlFor="firstname">
                  {t("filter.firstname")}
                </label>
                <DelayInput
                  id="firstname"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "firstname": event.target.value, page: 1 })}
                  name="firstname"
                  value={filterData["firstname"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="lastname">
                  {t("filter.lastname")}
                </label>
                <DelayInput
                  id="lastname"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "lastname": event.target.value, page: 1 })}
                  name="lastname"
                  value={filterData["lastname"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="email">E-mail</label>
                <DelayInput
                  id="email"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "email": event.target.value, page: 1 })}
                  name="email"
                  value={filterData["email"]}
                  type="text"
                />
              </StyledFilterGroup>
            </StyledFilterBlock>
          </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default SupportUserFilter;